function CompleteStatus() {
  return (
    <div className="inline-flex items-center justify-center px-[10px] py-[2px] rounded-[16px] bg-[#DCFCE7] font-OpenSansSemiBold font-[600] text-[#15803D] text-[14px] leading-[20px] tracking-[0.14px] capitalize [mix-blend-mode:multiply]">
      Complete
    </div>
  );
}

export default CompleteStatus;
